import {
  CLIENT_SET_TOKEN,
  CLIENT_AUTH_TOKEN_KEY,
  ORDER_AUTHORIZE_THIRD_PARTY_VERIFIER_REPORT,
  ORDER_VIEW_THIRD_PARTY_VERIFIER_REPORT,
  ORDER_GET,
  ORDER_REQUEST,
  ORDER_SUCCESS,
  ORDER_ERROR,
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  orders: null,
  current: null,
  report: null,
  isLoading: false,
  error: null,
}

const getters = {
  getCurrentOrder: (state) => state.current,
  getOrderReport: (state) => state.report,
  isOrderLoading: (state) => state.isLoading,
  getOrderError: (state) => state.error,
}

const actions = {
  [ORDER_GET]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_REQUEST)

      axios
        .get(`/api/v1/orders/${id}/`)
        .then((resp) => {
          commit(ORDER_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_AUTHORIZE_THIRD_PARTY_VERIFIER_REPORT]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_REQUEST)

      axios
        .post(`/api/v1/orders/${id}/authorize_report/`)
        .then((resp) => {
          commit(ORDER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_ERROR, err)
          reject(err)
        })
    })
  },
  [ORDER_VIEW_THIRD_PARTY_VERIFIER_REPORT]: ({ commit }, { id, reportId, format }) => {
    return new Promise((resolve, reject) => {
      commit(ORDER_REQUEST)

      const options = {}

      if (format) {
        options.responseType = 'blob'
      }

      axios
        .get(
          `/api/v1/orders/${id}/view_report?report_id=${reportId}${format ? `&response_format=${format}` : ''}`,
          options,
        )
        .then((resp) => {
          commit(ORDER_SUCCESS, { report: format === 'pdf' ? null : resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(ORDER_ERROR, err)
          reject(err)
        })
    })
  },
  [CLIENT_SET_TOKEN]: (_, token) => {
    return new Promise((resolve) => {
      localStorage.setItem(CLIENT_AUTH_TOKEN_KEY, token)
      resolve()
    })
  },
}

const mutations = {
  [ORDER_REQUEST]: (state) => {
    state.isLoading = true
  },
  [ORDER_SUCCESS]: (state, { current, report } = {}) => {
    state.isLoading = false

    if (current !== undefined) {
      state.current = current
    }
    if (report) {
      state.report = report
    }
  },
  [ORDER_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
